import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import styled, { css } from "styled-components";

export const ReleaseMetricCard = styled(Flex)<{ $highlight?: boolean; $error?: boolean }>`
  position: relative;
  background: linear-gradient(rgb(32, 32, 32), rgb(32, 32, 32)) padding-box padding-box,
    linear-gradient(161.27deg, rgb(58, 58, 60) 0%, rgb(32, 32, 32) 50.64%) border-box border-box;
  border: 1px solid transparent;
  border-radius: 2rem;
  padding: 2.8rem 2.8rem 3.2rem 3.2rem;
  overflow: hidden;
  flex: 1;
  box-sizing: border-box;

  ${(props) =>
    props.$highlight &&
    css`
      background: linear-gradient(rgb(32, 32, 32), rgb(32, 32, 32)) padding-box padding-box,
        linear-gradient(161.27deg, rgb(255, 186, 122) 0%, rgb(32, 32, 32) 50.64%) border-box border-box;
    `}

  ${(props) =>
    props.$error &&
    css`
      border: 1px solid ${vars.colors.red};
    `}
`;

export const ReleaseMetricIcon = styled.img`
  width: 4rem;
  height: 4rem;
  min-width: 4rem;
  margin-left: -0.8rem;
`;

export const ReleaseMetricHeading = styled(Flex)`
  justify-content: space-between;
  margin-top: -0.3rem;
`;

export const ReleaseMetricMoreButton = styled.button`
  border: 1px solid #48484a;
  width: 3.4rem;
  height: 3.4rem;
  background: #2c2c2e;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ReleaseMetricScore = styled.div<{ $gradient: string }>`
  width: 3rem;
  height: 3rem;
  min-width: 3rem;
  background: ${({ $gradient }) => $gradient};
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ReleaseMetricScoreText = styled(Paragraph)`
  font-family: Roobert, serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  color: ${vars.colors.white};
`;
